module.exports = __webpack_public_path__ + "static/header-mobile-13f7b3094e1a71de8d93f156a7b5ef4e.png";